<template>
  <base-page-layout title="Sorteios" :filters="[]">
    <raffle-type-dialog v-if="showRaffleTypeDialog" @input="closeRaffleTypeDialog" />
    <raffle-term-warning v-model="showTermWarning" />
    <v-row class="px-3 mb-2 mt-n2" justify="end">
      <mf-button label="Novo sorteio" icon="add" @click="openNewRaffleDialog" />
    </v-row>
    <raffle-index-table />
  </base-page-layout>
</template>

<script>
export default {
  name: 'ListRaffles',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    RaffleIndexTable: () => import('@/modules/mobile/sorteio/views/components/RaffleIndexTable.vue'),
    RaffleTypeDialog: () => import('@/modules/mobile/sorteio/views/components/RaffleTypeDialog.vue'),
    RaffleTermWarning: () => import('@/modules/mobile/sorteio/views/components/RaffleTermWarning.vue'),
  },
  data: () => ({
    showRaffleTypeDialog: false,
    showTermWarning: false,
  }),
  methods: {
    openNewRaffleDialog() {
      if (this.$getAllowedModules()['raffle_signed_terms']) {
        this.showRaffleTypeDialog = true
      } else {
        this.showTermWarning = true
      }
    },
    closeRaffleTypeDialog() {
      this.showRaffleTypeDialog = false
    },
  },
}
</script>
